let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lR3x0")).then(() => parcelRequire('j8CrR'));